import { programCustomTypography, scopes as scopesStore } from 'app/store/index';
import store from 'app/store/store';

export function getCustomTypographyDefault() {
  const state = store.getState();
  const customTypography = programCustomTypography.selectors.getCustomTypography(state);
  const scopes = scopesStore.selectors.getScopes(state);

  const heading_typeface = customTypography?.find((item) => item.name === 'Dosis')?.guid;
  const body_typeface = customTypography?.find((item) => item.name === 'Lato')?.guid;

  const heading_typeface_default = heading_typeface || scopes?.find((item) => item.scope === 'font-first')?.json;
  const body_typeface_default = body_typeface || scopes?.find((item) => item.scope === 'font-second')?.json;

  return {
    heading_typeface_default,
    body_typeface_default,
  };
}
